import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ToggleSidebar from "./ui/ToggleSidebar";

const AdminSidebar = ({ isMobileMenuOpen, setIsMobileMenuOpen }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const hasPermission = (permission) => {
        // SuperAdmin (Role 1) has all permissions
        if (user?.role_id === 1) return true;
        // Admin (Role 2) has basic access, check specific flags
        return user?.role_id === 2 || user?.permissions?.includes(permission);
    };

    // Base Menu Items (Matching HR Sidebar)
    let menuItems = [
        { key: "dashboard", label: "Dashboard", to: "/admin/dashboard" },
        { key: "employees", label: "Employees", to: "/admin/employees" },
        { key: "departments", label: "Departments", to: "/admin/departments" },
        { key: "designations", label: "Designations", to: "/admin/designations" },
        { key: "attendance", label: "Attendance", to: "/admin/attendance" },
        { key: "leaves", label: "Leaves", to: "/admin/leaves" },
        { key: "holidays", label: "Holidays", to: "/admin/holidays" },
        { key: "policies", label: "Leave Policies", to: "/admin/leave-policies" },
        { key: "documents", label: "Documents", to: "/admin/documents" },
        { key: "announcements", label: "Announcements", to: "/admin/announcements" },
        { key: "meetings", label: "Meetings", to: "/admin/meetings" },
        // Explicitly EXCLUDING System Settings and User Management
    ];

    // Permission-based Additions (Salary & Payslips)
    // Admin (Role 2) or anyone with permission can access
    if (user?.role_id === 2 || hasPermission("can_manage_salaries") || hasPermission("can_view_salaries")) {
        menuItems.push({ key: "salaries", label: "Salaries", to: "/admin/salaries" });
        // Payroll Settings
        if (hasPermission("can_manage_salaries")) {
            menuItems.push({ key: "payroll-settings", label: "Payroll Settings", to: "/admin/payroll-settings" });
        }
    }

    if (user?.role_id === 2 || hasPermission("can_manage_payslips")) {
        menuItems.push({ key: "payslips", label: "Payslips", to: "/admin/payslips" });
    }

    if (user?.role_id === 1 || user?.can_assign_tasks) {
        menuItems.push({ key: "tasks", label: "Tasks / Productivity", to: "/admin/tasks" });
    }

    const handleLogout = () => {
        logout();
        navigate("/login", { replace: true });
    };

    return (
        <ToggleSidebar
            title="HRMS"
            subtitle="Admin Portal"
            menuItems={menuItems}
            onLogout={handleLogout}
            isMobileMenuOpen={isMobileMenuOpen}
            setIsMobileMenuOpen={setIsMobileMenuOpen}
        />
    );
};

export default AdminSidebar;
